import { isDevMode, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { rootReducers, RootState } from './root-state';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { clearStateMetaReducer } from './root.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const metaReducers: MetaReducer<RootState>[] = [clearStateMetaReducer];

@NgModule({
  imports: [
    EffectsModule.forRoot([]),
    StoreModule.forRoot(rootReducers, { metaReducers, runtimeChecks: { strictStateImmutability: false } }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: isDevMode() }),
  ],
})
export class RootStoreModule {}
